import React from 'react';

function formatError(error) {
  if (!error) return 'Erro desconhecido.';
  if (typeof error === 'string') return error;
  const name = error.name ? `Nome: ${error.name}` : '';
  const message = error.message ? `Mensagem: ${error.message}` : '';
  const stack = error.stack ? `Stack:\n${error.stack}` : '';
  return [name, message, stack].filter(Boolean).join('\n\n') || String(error);
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('[app-error-boundary]', error, errorInfo);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    const details = [
      formatError(this.state.error),
      this.state.errorInfo?.componentStack || '',
    ].filter(Boolean).join('\n\n');

    return (
      <div className="min-h-screen bg-slate-950 text-white px-4 py-8">
        <div className="max-w-xl mx-auto rounded-2xl border border-red-500/40 bg-red-950/30 p-5">
          <h1 className="text-lg font-semibold">Falha ao iniciar o app</h1>
          <p className="mt-2 text-sm text-slate-200">
            O app capturou um erro de execucao. Use esta mensagem para corrigir o problema.
          </p>
          <pre className="mt-4 overflow-auto whitespace-pre-wrap break-words rounded-xl bg-black/40 p-3 text-xs text-red-100">
            {details}
          </pre>
        </div>
      </div>
    );
  }
}
